<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                   <v-btn dark icon title="Back to Cutoff List" @click="$router.push('/company/timesheets')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>         
                    <v-text-field v-model="search" dark append-icon="search" label="Search employee name, team" single-line hide-details style="margin-bottom:5px;"></v-text-field>
                    <v-spacer></v-spacer>
                    <help-link appId="company" pageId="timesheets" color="white"></help-link>
                    <b class="white--text">{{cutOffPeriod}}</b>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            <div v-for="(item, index) in teams_filterd" :key="index">
                <v-card class="elavation-1" style="margin-top:5px;"> 
                    <v-toolbar flat height="35px">
                        <span class="font-weight-bold">{{item}}</span>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-data-table
                        :headers="headers"
                        :items="getTimeReportByTeam(item)"
                        :loading="loading" 
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                    >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template v-slot:items="props">
                            <tr @click="viewUserTimesheet(props.item)" title="Click to view details, approve, reject" style="cursor:pointer;" >
                                <td>
                                    <v-chip @click="viewUserProfile(props.item, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                        </v-avatar>
                                        {{props.item.firstName}} {{props.item.lastName}}
                                    </v-chip>
                                </td>
                                <td>
                                    <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                </td>
                                <td>
                                    <span v-if="props.item.createdOn">{{ props.item.createdOn | moment('MMM DD, YYYY')}}</span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>

import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {
    name: 'AllTimesheets',
    metaInfo: {
        title: 'AllTimesheets',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View all company users timesheets then extract reports to excel.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'40%', sortable:true},
                {text: 'Timesheet Status', align: 'left', value: 'status', width: '30%', sortable:true},
                {text: 'Created On', align: 'left', value: '', width: '30%', sortable:false}
            ],
            search: null,
            cutoff_details: [],
            time_reports: [],
            teams: []
        }
    },
    methods: {
        viewUserTimesheet(data) {
            this.$router.push(`${this.selectedCutOffId}/${data.userId}`)
        },
        getTimeReportByTeam(team) {
            return this.time_reports_filtered.filter(item => {
                return item.team == team
            })
        },
        async downloadToExcel() {
        },
        async getCompanyTimeReports() {
            try {
                this.loading = true
                const response = await timesheetApi.getTimeReportByCompany(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.time_reports = response.data.items
                    this.cutoff_details = response.data.cutOffItem
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
          }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Company Timesheets'
        })
        
        this.getCompanyTimeReports()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
        },
        time_reports_filtered() {
            var temp = this.time_reports
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return item.firstName.toLowerCase().includes(this.search.toLowerCase()) || 
                            item.lastName.toLowerCase().includes(this.search.toLowerCase()) ||
                            item.team.toLowerCase().includes(this.search.toLowerCase())
                })
            }
            return temp
        },
        teams_filterd() {
            return this.time_reports_filtered
                        .map(item => item.team)
                        .filter((value, index, self) => self.indexOf(value) === index)
        }
    }
}
</script>